import { render, staticRenderFns } from "./ApplicantForgetPassword.vue?vue&type=template&id=3aedc72f&scoped=true&"
import script from "../../services/applicant/applicant-forget-password.js?vue&type=script&lang=js&"
export * from "../../services/applicant/applicant-forget-password.js?vue&type=script&lang=js&"
import style0 from "./ApplicantForgetPassword.vue?vue&type=style&index=0&id=3aedc72f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aedc72f",
  null
  
)

export default component.exports